import axios from 'axios';
import qs from 'qs';
import {getToken, setToken,removeToken} from '@/utils/auth.js'
import md5 from 'js-md5';
import {urlpostfix,jsonpostfix} from '@/config/global.js'
const  BASE_URL = process.env.BASE_URI_API;
/*http://yinglie.chinamartyrs.gov.cn/JSON
  http://192.168.0.148:8022/*/
// axios 配置
var instance = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
     //接口请求地址
});
instance.defaults.baseURL = BASE_URL;
// //拦截重复请求
// let pending = []; //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
// let cancelToken = axios.CancelToken;
// let removeRepeatUrl = (config) => {
//   let comValue = config.method == 'get' ? qs.stringify(config.params) : qs.stringify(config.data);
//   for (let p in pending) {
//     if (pending[p].u === config.url + '&' + config.method + '&' + comValue) { //当前请求在数组中存在时执行函数体
//       pending[p].f();         //执行取消操作
//       pending.splice(p, 1);   //把这条记录从数组中移除
//     }
//   }
// };
// let saveRepeatUrl = (config) => {
//   let comValue = config.method == 'get' ? qs.stringify(config.params) : qs.stringify(config.data);
//   console.log(comValue)
//   config.cancelToken = new cancelToken((c) => {
//     pending.push({u: config.url + '&' + config.method + '&' + comValue, f: c});  // 自定义唯一标识
//   });
// };
//
// // 添加请求拦截器
// instance.interceptors.request.use(config => {
//   // 在发送请求之前做些什么，比如传token
//   removeRepeatUrl(config);       //在一个ajax发送前执行一下取消操作
//   saveRepeatUrl(config);         //保存请求地址
//
//
//   return config
// }, error => {
//   // 对请求错误做些什么
//   console.log(error) // for debug
//   return Promise.reject(error);
// });
//
// // 添加响应拦截器
// instance.interceptors.response.use(response => {
//   removeRepeatUrl(response.config);        //执行取消操作，把已经完成的请求从pending中移除
//   // 对响应数据做点什么
//   const res = response.data;
//   //对错误代码做处理
//   return response;
// }, error => {
//   // 对响应错误做点什么
//   console.log('err' + error)
//   // for debug
//   return Promise.reject(error);
// });

export default instance;

/**
 * post 请求方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data = {}) {
  return request("post", url, data);
}

/**
 * get 请求方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url, data = {}) {
  return request("get", url, data);
}


/**
 * Json 请求方法
 * @param url
 * @param data
 * @returns {Promise}
 */


export function moke(methed,url, data = {}) {
 if(methed == "get"){
   instance.get(url, {
     params: {}
   }).then(res => {
     console.log(res);
   }).catch(err => {

   });
 }else {
   instance.post(url, {
     params: {}
   }).then(res => {
     console.log(res);
   }).catch(err => {

   });
 }
}



/**
 * 封装所有请求
 * @param methed
 * @param url
 * @param data
 * @param headers
 * @returns {Promise}
 */
export function request(methed, url, data = {}) {
  return new Promise((resolve, reject) => {
    instance({
      method: 'post',
      url: url,
      params: methed === 'get' ? data : '',
      data: methed !== 'get' ? getData(data) : '',
      headers: getHear(url, data),
    })
      .then(response => {
        if (response.data.code == 503) {
          removeToken();
          getUserToken().then(req => {
            instance({
              method: 'post',
              url: url,
              params: methed === 'get' ? data : '',
              data: methed !== 'get' ? getData(data) : '',
              headers: getHear(url, data),
            }).then(response => {
              resolve(response.data);
            });
          });
        } else {
          resolve(response.data);
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}

export function getUserToken() {
  return new Promise((resolve, reject) => {
    let token = getToken();
    if (!token) {
      instance.post(`${urlpostfix}getToken`).then(req => {
        if (req.data.code == 200) {
          setToken(req.data.data.token);
          resolve(req.data.data.token);
        }
      }, error => {
        reject(error)
      });
    } else {
      resolve(token);
    }
  });
}

export function getJSON(url) {
 return new Promise((resolve, reject) => {
  instance.get(url).then(response => {
      resolve(response.data);
    }).catch(err => {
    reject(err)
  })
 })
}


function getHear(url, data = {}) {
  let headers = {'Content-Type': 'application/json'};
  let timeStamp = new Date().getTime();
  let token = getToken();
  if (token) {
    let result = "";
    if (url.indexOf("?") != -1) {
      var urls = url.split("?");
      result = urls[urls.length - 1];
    }
    if (typeof data != 'string') {
      for (var key in data)
        result += (result ? "&" : "") + key + "=" + encodeURIComponent(data[key].toString());
    } else {
      result += (result ? "&" : "") + encodeURIComponent(data);
    }
    let autograph = md5(md5(timeStamp + result + token));
    instance.defaults.headers.common["Authorization"] = token;
    instance.defaults.headers.common["timeStamp"] = timeStamp;
    instance.defaults.headers.common["autograph"] = autograph;
    headers["timeStamp"] = timeStamp;
    headers["Authorization"] = token;
    headers["autograph"] = autograph;
  }
  return headers;
}

function getData(data) {
  let form = new FormData();
  if (data) {
    for (var key in data) {
      form.append(key, data[key])
    }
  }
  return form
}



// WEBPACK FOOTER //
// ./src/config/config.js